import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { SpinnerService } from 'src/app/core/services/spinner.service';

@Component({
  selector: 'app-mitel-one-config-dialog',
  templateUrl: './mitel-one-config-dialog.component.html',
  styleUrls: ['./mitel-one-config-dialog.component.scss']
})
export class MitelOneConfigDialogComponent implements OnInit {
  mitelOneForm = this.formBuilder.group ({
    avatarOptionId: [false, []]
  });
  allowAvatarChange: boolean;
  showFormError = false;
  errMsgStyle: any = { 'max-width': '500px' };
  submitted = false;
  changed = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
      public dialogRef: MatDialogRef<MitelOneConfigDialogComponent>,
      private translateService: TranslateService,
      private formBuilder: FormBuilder,
      private spinnerService: SpinnerService,
      private domSanitizer: DomSanitizer,
      private matIconRegistry: MatIconRegistry
  ) {
    this.matIconRegistry.addSvgIcon(
			'trash_can',
			this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/images/trash.svg")
		);
   }

  ngOnInit(): void {
    setTimeout(() => {  
      this.spinnerService.setSpinnerMessageByKey('spinnerMessages.loading_wait');
      this.spinnerService.showSpinner();

      this.data.product.service.getMitelOneConfiguration(this.data.account).then( value => {
        console.log("Mitel One config returned", value);
        this.allowAvatarChange = value.allowAvatarChange;

        this.mitelOneForm.controls['avatarOptionId'].patchValue(this.allowAvatarChange);
        setTimeout(() => {  
          this.spinnerService.hideSpinner();
        },1000);
    })
    .catch(err => {
      console.log("Error loading the mitel one configuration dialog", err);
      this.showFormError = true;
      this.spinnerService.hideSpinner();
    });
  });
  }

  allowAvatarNameStateChanged(){
    this.changed = true;
    this.showFormError = false;
  }

  onCancel() {
    this.dialogRef.close( );
  }
  
  onSave(){
    this.submitted = true;
    let config = {
      allowAvatarChange: this.mitelOneForm.controls['avatarOptionId'].value
    }
    this.spinnerService.setSpinnerMessageByKey('spinnerMessages.updatingAccount');
    this.spinnerService.showSpinner();
    this.data.product.service.saveMitelOneConfig(this.data.account, config).then( value => {
        this.submitted = false;
        this.spinnerService.hideSpinner();
				let result = 
				{
					setupComplete: true,
				}
				this.dialogRef.close( result);
    })
    .catch(err => {
        this.mitelOneForm.controls['avatarOptionId'].patchValue(this.allowAvatarChange);
        this.showFormError = true;
        this.spinnerService.hideSpinner();
        this.submitted = false;
    });
  }

  onRemoveIntegration()
	{
		console.log("Remove the integration - when successful, close the dialog");
		let result = 
		{
			remove: true
		}
		this.dialogRef.close( result);
	}
}
